// extracted by mini-css-extract-plugin
module.exports =  {"container":"_02712f2b3b--container--VT1L6","icon":"_02712f2b3b--icon--_5KHV","description":"_02712f2b3b--description--Yc3wj"};